import React, {Component} from 'react';
import './chatLandingSearch.scss';
import Hidden from "@material-ui/core/Hidden";
import {withStyles} from "@material-ui/core";
import {SearchDeskTop} from "./chatSearch-Icons";
import {SearchTablet} from "./chatSearch-Icons";
import {SearchMobile} from "./chatSearch-Icons";


const styles = theme => ({
  searchArea: {
    width: '60%',
    [theme.breakpoints.down('sm')]: {
      width: '90%'
    }
  },

  'input': {
    '&::placeholder': {

      [theme.breakpoints.only('xs')]: {
        width: '263px',
        height: '33px',
        fontFamily: 'XFINITYStandard',
        fontSize: 18,
        fontWeight: 300,
        fontStyle: 'normal',
        fontStretch: 'normal',
        lineHeight: 1.89,
        letterSpacing: 0.2,
        color: '#646a70'
      }

    }
  }

});

class chatLandingSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disabled:true,
      searchText: ''
    }

    this.clearSearch = this.clearSearch.bind(this);
    this.onButtonClicked = this.onButtonClicked.bind(this);
    this.onKeyPressed = this.onKeyPressed.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);

    this.searchInputRef = React.createRef();

  }

    focus=()=>
    {
      // document.getElementById('searchWrapperContainer').focus();
    }

  render() {
    const classes = this.props.classes;
    let val = {
      "eventName":"XA Send",
      "eventAction": this.state.searchText
    }

    return <div onLoad={this.focus} id='parentSearchContainer'

                onMouseMove={(event)=>{
                  this.onMouseEnter(event)}}
                onMouseOver={(event)=>{
                  this.onMouseEnter(event)}}
                onMouseEnter={(event)=>{
                  this.onMouseEnter(event)}}
               className='chatLanding-Search'>

    <div>
      <Hidden only={['sm', 'xs', 'md']}>
        <SearchDeskTop  width={816} height={496} focusable={false}/>
      </Hidden>
      <Hidden only={['sm', 'xs', 'xl', 'lg']}>
       <SearchTablet  width={653} height={607} focusable={false}/>
      </Hidden>
      <Hidden only={['md', 'xl', 'lg']}>
        <SearchMobile width={351} height={425} focusable={false}/>
      </Hidden>
    </div>

      <div  className={`${classes.searchArea} search-area`} data-tracking='{"container":["search-area"]}'>
        <div id='searchContainer'
               className={'searchInputContainer'}>
        <Hidden xsDown>

          <input id='searchField' role="textbox" aria-label="Enter your support comment here"  autocomplete='off' tabIndex='0' className={'search'}  type="text"  placeholder={this.props.placeHolder}
                 value={this.state.searchText}
                 ref={this.searchInputRef}
                 /*onMouseEnter={(event)=>{
                   this.onMouseEnter(event)}}
                 onMouseMove={(event)=>{
                   this.onMouseEnter(event)}}
                 onMouseDown={(event)=>{
                   this.onMouseEnter(event)}}
                 onMouseOver={(event)=>{
                   this.onMouseEnter(event)}}
                 onMouseLeave={(event)=>{
                   this.onMouseLeave(event)}}
                 onMouseOut={(event)=>{
                   this.onMouseLeave(event)}}*/
                 onKeyUp={(event)=>{
                   this.onKeyPressed(event)}}
                 onKeyPress={(event)=>{
                   this.onKeyPressed(event)}}
                 onChange={this.onSearchTextChange.bind(this)}
                 data-tracking='{"container":["search-box"]}'
          />

        </Hidden>
        <Hidden smUp>
          <input  data-tracking role="textbox" aria-label="Enter your support comment here"  autocomplete='off' tabIndex='0' className={'searchSmall'} type="text"  placeholder={this.props.placeHolder}
                 value={this.state.searchText}
                 ref={this.searchInputRef}
                 onKeyPress={(event)=>{
                 this.onKeyPressed(event)}}
                 onChange={this.onSearchTextChange.bind(this)}/>
        </Hidden>
        <Hidden xsDown>
          <button data-tracking= {JSON.stringify(val)}
              role="button" aria-label="Send" aria-disabled={this.state.disabled}
              className={this.state.searchText ? 'button filled' : 'button'}
              onClick={(event)=>{this.onButtonClicked(event,this.state.searchText)}}></button>
        </Hidden>
        <Hidden smUp>
          <button  data-tracking= {JSON.stringify(val)} role="button" aria-label="Send" aria-disabled={this.state.disabled}
              className={this.state.searchText ? 'button-small filled' : 'button-small'}
              onClick={(event)=>{this.onButtonClicked(event,this.state.searchText)}}/>
        </Hidden>
      </div>
      </div>
    </div>
  }


  clearSearch()
  {
    this.setState({searchText: ''});
    this.setState({disabled:true});
      if(this.searchInputRef.current!=null)
      this.searchInputRef.current.value='';


  }

  onButtonClicked(event,searchText)
  {
    if( searchText!=null && searchText.length>0) {
      this.props.defaultEvent(searchText, 'utterance');
    }
  }

  onKeyPressed(event){

    if (event.keyCode === 9) {
    if( document.getElementById('searchField')!=null) {
      document.getElementById('searchField').classList.remove('searchMouse');
    }
    }
    if (event.shiftKey && event.charCode === 13) {
      return true;
    }
    if (event.charCode === 13) {

      event.preventDefault();
      if (event.target.getAttribute('value') != null) {
        if (event.target.getAttribute('value').length > 0) {
          this.setState({searchText: event.target.getAttribute('value')});
          this.setState({disabled:true});
          this.props.keyBoardEvent(event.target.getAttribute('value'), 'utterance');
          return false;
        }
      }

    }
  }

  onMouseEnter(event) {
    if( document.getElementById('searchField')!=null) {
      document.getElementById('searchField').classList.add('searchMouse');
    }
  }

  onMouseLeave(){
    if( document.getElementById('searchField')!=null) {
      document.getElementById('searchField').classList.remove('searchMouse');
    }
  }



  onSearchTextChange(event) {

    this.setState({searchText: event.target.value});
    if(event.target.value.length>0)
    {
      this.setState({disabled:false});
    }
    else {
      this.setState({disabled:true});
    }
  }
}

export default withStyles(styles)(chatLandingSearch);
